angular.module('services.newman.MagicService', [
  'global'
])

/**
 * The MagicService service stores methods used to access
 * system APIs.
 *
 * @class MagicService
 * @constructor
 * @module services.newman.MagicService
 */
.factory('MagicService', [
  function () {
    'use strict';

    var service = {


    };

    return service;
  }
]);
